import { logError } from '@utils/tools/ErrorLoggers';

export const ENC_HOUSEHOLD_ID_SESSION_KEY = 'encHouseHoldId';
/** Session key written by JSP (`consumerSummaryNavigation.jsp`) and SPA sync. */
export const USER_REF_ID_SESSION_KEY = 'userRefId';

export const getStoredUserRefId = (): string => {
    try {
        const value = sessionStorage.getItem(USER_REF_ID_SESSION_KEY);
        return typeof value === 'string' ? value.trim() : '';
    } catch {
        return '';
    }
};

export const setStoredUserRefId = (refId: string): void => {
    try {
        if (refId) {
            sessionStorage.setItem(USER_REF_ID_SESSION_KEY, refId);
        } else {
            sessionStorage.removeItem(USER_REF_ID_SESSION_KEY);
        }
    } catch {
        // sessionStorage unavailable (private mode / storage disabled); the ref id still
        // lives in Redux, so this is non-fatal — log for visibility only.
        logError('setStoredUserRefId: sessionStorage unavailable');
    }
};

export const normalizeUserRefId = (value: string | null | undefined): string => {
    return typeof value === 'string' ? value.trim() : '';
};

/** Priority: URL/query `referenceId`, then the loaded household's ref, then session cache (JSP or prior sync). */
export const resolveSideNavReferenceId = (
    routeReferenceId?: string | null,
    householdRefId?: string | null,
): string => {
    return normalizeUserRefId(routeReferenceId) || normalizeUserRefId(householdRefId) || getStoredUserRefId();
};

/** Exception-safe read (private mode / disabled storage should not crash the sidenav). */
export const getStoredEncHouseholdId = (): string | null => {
    try {
        return sessionStorage.getItem(ENC_HOUSEHOLD_ID_SESSION_KEY);
    } catch {
        return null;
    }
};

/** Exception-safe write, symmetric with getStoredEncHouseholdId. */
export const setStoredEncHouseholdId = (encHouseholdId: string): void => {
    try {
        sessionStorage.setItem(ENC_HOUSEHOLD_ID_SESSION_KEY, encHouseholdId);
    } catch {
        logError('setStoredEncHouseholdId: sessionStorage unavailable');
    }
};
